import React, { useContext }       from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import AdjustableScreen            from "../../layouts/AdjustableScreen/index.web";
import InboxScreen                 from "../InboxScreen/index.web";
// import SettingsScreen              from "~/screens/SettingsScreen/index.web";

import AppContext                  from "../../contexts/AppContext";

export default function HomeCompactScreen() {
  const { lastConversationId, compactMode } = useContext(AppContext);

  if (!compactMode) return <Redirect to="/" />;

  return (
    <AdjustableScreen>
      <Switch>
        {/* <Route path="/compact/settings">
          <SettingsScreen />
        </Route> */}
        <Route path="/compact/messages">
          <InboxScreen />
        </Route>
        <Route>
          {lastConversationId ? (
            <Redirect to={`/compact/messages/${lastConversationId}`} />
          ) : (
            <Redirect to={`/compact/messages`} />
          )}
        </Route>
      </Switch>
    </AdjustableScreen>
  );
}
